import { render, staticRenderFns } from "./AdFormatsData.vue?vue&type=template&id=627b4895"
import script from "./AdFormatsData.vue?vue&type=script&lang=js"
export * from "./AdFormatsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports